"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../dsl/backoffice");
/**
 * Component responsible for display one ListItem
 *
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ListItemForm = class ListItemForm extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.child = {
            children: [],
            meta: { isLoose: false, isOrdered: false, start: '' },
            text: ''
        };
        this.DashmixIconName = backoffice_1.DashmixIconName;
    }
    mounted() {
        const tempItem = { ...this.item };
        if (!Object.prototype.hasOwnProperty.call(tempItem, 'meta')) {
            tempItem.meta = { isLoose: false, isOrdered: false, start: '' };
        }
        if (!Object.prototype.hasOwnProperty.call(tempItem, 'children')) {
            tempItem.children = [];
        }
        if (!Object.prototype.hasOwnProperty.call(tempItem, 'text')) {
            tempItem.text = '';
        }
        this.$emit('updateItem', this.index, tempItem);
    }
    get childrenBgClass() {
        if (this.bgClass === 'bg-gray-lighter') {
            return 'bg-gray-light';
        }
        return 'bg-gray-lighter';
    }
    get hasChildren() {
        if (!this.item.children) {
            return false;
        }
        return this.item.children.length > 0;
    }
    getPointerClass() {
        return !this.isOrdered ? 'list-form__unnumbered' : 'list-form__numbered';
    }
    addChild() {
        const itemCopy = { ...this.item };
        if (!itemCopy.children) {
            itemCopy.children = [JSON.parse(JSON.stringify(this.child))];
        }
        itemCopy.children.push(JSON.parse(JSON.stringify(this.child)));
        this.$emit('updateItem', this.index, itemCopy);
    }
    deleteItem(index) {
        const itemCopy = this.item;
        if (!itemCopy.children) {
            return;
        }
        itemCopy.children.splice(index, 1);
        this.$emit('updateItem', this.index, itemCopy);
    }
    onDelete() {
        this.$emit('deleteItem', this.index);
    }
    updateItem(index, newItemChildren) {
        const itemCopy = { ...this.item };
        if (!itemCopy.children) {
            return;
        }
        itemCopy.children[index] = newItemChildren;
        this.$emit('updateItem', this.index, itemCopy);
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: true }),
    __metadata("design:type", String)
], ListItemForm.prototype, "bgClass", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], ListItemForm.prototype, "index", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], ListItemForm.prototype, "item", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: true }),
    __metadata("design:type", String)
], ListItemForm.prototype, "isOrdered", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", String)
], ListItemForm.prototype, "treeLevel", void 0);
ListItemForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'ListItemForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput
        },
        template: `
    <li class="mt-2">
      <!-- Main meta -->
          <div class="row m-0 p-3 align-items-center" :class="bgClass">
            <div class="col-11">
              <div class="form-group mb-2">
                <label for="meta-start" class="d-block">{{ $t('forms.list.text') }}</label>
                <div class="list-form__text-form">
                  <span class="mr-2" :class="getPointerClass()" >
                    <b>{{ isOrdered ? index + 1 + '.' : '' }}</b>
                  </span>
                  <DashmixInput size="small" :model.sync="item.text" name="text" />
                </div>
              </div>

              <DashmixCheck v-if="hasChildren" class="pb-1" :model.sync="item.meta.isOrdered"
                            :name="'meta-isOrdered.' + this.index + '.' + treeLevel" :label="$t('forms.list.isOrdered')" />

              <DashmixButton  :label="$t('forms.list.addChild')" @click="addChild"
                              :icon="DashmixIconName.PlusSolid" variant="icon" />
            </div>

            <DashmixButton class="col-1" variant="icon" :icon="DashmixIconName.TrashSolid" theme="danger"
                           @click="onDelete" />
          </div>

          <ul v-if="hasChildren" v-for="(child, index) in item.children" :style="{ listStyle: 'none' }" >
            <ListItemForm :item="child" :index="index" :bgClass="childrenBgClass" :treeLevel="treeLevel + 1"
                          :isOrdered="item.meta.isOrdered"
                          @updateItem="updateItem" @deleteItem="deleteItem" />
          </ul>
    </li>`
    })
], ListItemForm);
exports.ListItemForm = ListItemForm;
//# sourceMappingURL=ListItemForm.js.map